import { api } from "./api";
import { solvePow } from "./pow";

export async function hasSession(): Promise<boolean> {
  try {
    await api.me();
    return true;
  } catch {
    return false;
  }
}

/**
 * Гарантирует, что у нас есть сессия: при необходимости решает PoW.
 * Нужна там, где действие создаёт данные (форк, сохранение), а не только читает.
 */
export async function ensureSession(
  onProgress?: (p: { attempts: number; elapsedMs: number }) => void,
): Promise<void> {
  if (await hasSession()) return;
  const challenge = await api.createChallenge();
  const { promise } = solvePow(challenge.prefix, challenge.difficulty, onProgress);
  const nonce = await promise;
  await api.establishSession(challenge.id, nonce);
}
